import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { displayType } from './district-map-intreface';
import { initOpts } from '../../config/initOpts';
import { fromEvent } from 'rxjs';
import { ECharts, registerMap } from 'echarts';
import * as _ from 'lodash';
import * as map from '../../mapsFile/mapsFile';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { DistrictMapService } from './district-map.service';
import { HttpClient } from '@angular/common/http';
import { getGeoCoordMap } from '../../mapsFile/mapsFile';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { DistrictMapIntreface } from './district-map-intreface';
import { ChartResizeService } from '../../service/chart-resize.service';


@Component({
  selector: 'bcac-district-map',
  templateUrl: './district-map.component.html',
  styleUrls: ['./district-map.component.scss']
})
export class DistrictMapComponent implements OnInit {

  constructor(
    private districtMapService: DistrictMapService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private http: HttpClient
  ) { }

  initOpts;
  ngOnInit() {
    registerMap('myMap', map.map_bejing);
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      let style = this.commonService.changeFontSize();
      // this.commonService.setMapChartResize(this.echartInstance, style)
      this.chartResizeService.autoMapResizeAdapt(this.echartInstance, this.chartOption)
    })
  }

  _displayType: displayType = 'area';  //默认显示类型为区域
  _mapUrl: string = '';  //地图地址
  geoCoordMap: any = map.geoCoordMap_beijing;  //默认地图数据
  // 图配置
  chartOption: any = this.districtMapService.getDistrictMapDefaultOptions(this._displayType);

  _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "地图"
  }

  // 输入标题
  @Input()
  set bcacChartTitleText(chartTitle: string) {
    this._bcacChartTitle.label = chartTitle
  }
  // 输入标题是否显示
  @Input()
  set bcacChartShowTitle(showTitle: boolean) {
    this._bcacChartTitle.show = showTitle
  }
  // 下载图片文件名
  _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }
  // 地图地址
  @Input()
  set bcacMapUrl(mapUrl: string) {
    this._mapUrl = mapUrl;
    this.updateMapUrl();
  }

  // 显示类型（area：默认 point）
  _bcacDisplayType: displayType = 'area';
  @Input()
  set bcacDisplayType(bcacDisplayType: displayType) {
    this._bcacDisplayType = bcacDisplayType;
    this.districtMapService.changeDisplayType(this.chartOption, bcacDisplayType);
  }
  // 修改visualMap类型
  // @Input()
  // set bcacVisualMap(
  //   visualMap: {
  //     type: "continuous";
  //     data: { min: number; max: number; color?: string[] }
  //   }
  //     | { type: "piecewise"; data: { [key: string]: any }[] }
  // ) {
  //   this.districtMapService.changeVisualMap(this.chartOption, this._bcacDisplayType, visualMap);
  //   this.updateMapUrl();
  // }

  customToolboxShow: boolean = false;
  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];
  // 数据选择区域
  @Input()
  set bcacDataSourceList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && selectList[0].hasOwnProperty('optList')) {
        this._selectList = selectList;
      } else {
        this._selectList = [];
      }
    } else {
      this._selectList = []
    }
  }

  visualMapPosition: 'left' | 'right' = "left";
  _bcacChartData: any = [];
  _visualMapType = 'continuous';
  // 数据
  @Input()
  set bcacChartData(chartData: any) {

    if (chartData.hasOwnProperty('data')) {
      if (chartData.hasOwnProperty('visualMap') && chartData.visualMap.hasOwnProperty('type')) {
        this._visualMapType = chartData.visualMap.type;
      }

      this.districtMapService.changeVisualMap(this.chartOption, this.visualMapPosition, this._bcacDisplayType, chartData.visualMap, this._dimension, this.darkMode)
      this.districtMapService.changeChartData(this.chartOption, this._bcacDisplayType, chartData, this.geoCoordMap)

    } else {
      this.districtMapService.changeChartData(this.chartOption, this._displayType, {}, this.geoCoordMap)
    }
    this.updateMapUrl();
  }


  _dimension = 0;
  // 设置映射维度
  @Input()
  set bcacDimension(dimension: number) {
    this._dimension = dimension;
    this.districtMapService.changeVisualmapDimension(this.chartOption, this._bcacDisplayType, dimension);
    this.updateMapUrl();
  }

  // 设置dimension名
  @Input()
  set bcacDimensionNames(dimensionNames: { [key: string]: string }[]) {
    this.districtMapService.changeDimensionNames(this.chartOption, this._bcacDisplayType, dimensionNames)
    this.updateMapUrl();
  }

  // visualMap位置
  @Input()
  set bcacVisualMapPosition(position: 'left' | 'right') {
    this.visualMapPosition = position;
    this.districtMapService.changeVisualMapPosition(this.chartOption, position)
    this.updateMapUrl();
  }

  darkMode: boolean | string = false;
  // 开启暗模式
  @Input()
  set bcacDarkMode(darkMode: boolean | string) {

    this.darkMode = darkMode;

    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.districtMapService.openDarkMode(this.chartOption, darkMode);
  }

  // 设置geoLabel是否显示
  @Input()
  set bcacGeoShowLabel(show: boolean) {
    this.districtMapService.changeGeoShowLabel(this.chartOption, show);
  }

  // 设置toolbox是否显示
  @Input()
  set bcacChartShowToolbox(chartShowToolbox: boolean) {
    // this.districtMapService.changeToolboxShow(this.chartOption, chartShowToolbox)
  }

  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();



  // ECharts实例
  echartInstance: ECharts = null;
  onOptionInit(ec) {
    if (ec) {
      this.echartInstance = ec;
    }
  }
  // 选择数据源切换
  selectedDataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  // 更改地图
  updateMapUrl() {
    this.http.get(this._mapUrl).subscribe((geoJson) => {
      registerMap('myMap', geoJson);
      this.geoCoordMap = getGeoCoordMap(geoJson);
      if (this.echartInstance) {
        this.echartInstance.setOption(this.chartOption, true);
      }
    })
  }

  // 转换数据
  convertData = (data, geoCoordMap) => {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value)
        });
      }
    }
    return res;
  }

  _chartTitleColor: string = ''
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this._chartTitleColor = ''
    } else {
      this._chartTitleColor = color.darkModeTextColor;
    }
  }

  _cardBackgroundColor = "#FFF";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this._cardBackgroundColor = darkMode;
    } else if (darkMode) {
      this._cardBackgroundColor = backgroundColor.darkModeBGColor;
    }
  }

  chartRestore() {
    if (this.echartInstance) {
      this.echartInstance.dispatchAction({
        type: 'restore'
      })
    }
  }

}
